export default "__VITE_ASSET__b2beab62__"